import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionTeacherDssChatHistory = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const [teacherList, setTeacherList] = useState([])
    const [teacherMasterId, setTeacherMasterId] = useState("");
    const [teacherDssReport, setTeacherDssReport] = useState([]);
    const [editId, setEditId] = useState(null)

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getTeacherList();
    }, []);

    const getTeacherList = () => {
        const apiUrlForSyllabus = `/get-teacher?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setTeacherList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const showReport = async (e) => {
        const { name, value } = e.target;
        setTeacherMasterId(value);

        try {
            const apiUrl = `/get-teacher-dss-report-chat-history?sectionMasterId=${sectionMasterId}&teacherMasterId=${value}`;
            const response = await authorizedAxiosCommon.get(apiUrl);
            setTeacherDssReport(response.data.result)
        } catch (error) {
            setTeacherDssReport([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    // const textChatStatus = (tc_status, vc_status) => {
    //     if (dss_status === 'P') {
    //         return "Pending";
    //     } else if ()
    // }

    // const videoChatStatus = (vc_status) {}

    const handleInputReset = () => {
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div id='scroll-up'></div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Teacher DSS Report</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-chart-bar"></i>Teacher DSS Report</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Teacher:</label>
                                                    <select class="form-select" aria-label="Default select example" disabled={editId} name='teacherMasterId' onChange={showReport} value={teacherMasterId}>
                                                        <option selected value={''} disabled>Select Teacher</option>
                                                        {
                                                            teacherList?.map((teacher) => {
                                                                return <option value={teacher.id}>{teacher.teacherName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>Chat Title</th>
                                                                        <th scope='col'>Teacher Name</th>
                                                                        <th scope='col'>Student Name</th>
                                                                        <th scope='col'>Class</th>
                                                                        <th scope='col'>Division</th>
                                                                        <th scope="col">Subject Name</th>
                                                                        <th scope="col">Text Chat</th>
                                                                        <th scope="col">Video Chat</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {teacherDssReport?.length > 0 ? (
                                                                        teacherDssReport?.map((dss, index) => (
                                                                            <tr key={index}>
                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                <td>{dss?.title}</td>
                                                                                <td>{dss?.teacherMasterDetails?.teacherName}</td>
                                                                                <td>{dss?.studentMasterDetails?.studentName}</td>
                                                                                <td>{dss?.studentMasterDetails?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                <td>{dss?.studentMasterDetails?.instituteDivisionMasterDetails?.divisionName}</td>
                                                                                <td>{dss?.instituteSubjectMasterDetails?.subjectName || dss?.subjectMaster?.subjectName}</td>
                                                                                <td>{dss.tc_status === "" ? "Not requested for text chat" : dss.tc_status === "P" ? "Request Pending" : dss.tc_status === "S" ? "Ongoing" : dss.tc_status === "E" ? "Ended" : "Rejected"}</td>
                                                                                <td>{dss.vc_status === "" ? "Not requested for video chat" : dss.vc_status === "P" ? "Request Pending" : dss.vc_status === "S" ? "Ongoing" : dss.vc_status === "E" ? "Ended" : "Rejected"}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <th colSpan={"14"} style={{ textAlign: 'center' }}>No Teacher Available</th>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionTeacherDssChatHistory;